// ✅ 8. src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { decodeToken } from '../utils/jwt';
import { initAuthApi } from '../api/authApi';
import { initBlogApi } from '../api/blogApi';
import { initBoardApi } from '../api/boardApi';
import { initTodoApi } from '../api/todoApi';
import { initAnsibleApi } from '../api/ansibleApi';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  const logout = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    setUser(null);
    setIsLoggedIn(false);
  };

  const login = (tokenObj) => {
    localStorage.setItem('access', tokenObj.access);
    localStorage.setItem('refresh', tokenObj.refresh);
    const decoded = decodeToken(tokenObj.access);
    setUser(decoded);
    setIsLoggedIn(true);
  };

  useEffect(() => {
    const token = localStorage.getItem('access');
    if (token) {
      const decoded = decodeToken(token);
      setUser(decoded);
      setIsLoggedIn(true);
    }

    // ✅ API 초기화 시 logout 주입
    initAuthApi(logout);
    initBlogApi(logout);
    initBoardApi(logout);
    initTodoApi(logout);
    initAnsibleApi(logout);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);